import * as types from "../actions/types";


const initialState = {
  studyPeriod: [],
  lessons: [],
  scClass: [],
  classbook: [],
  gradeValue: [],
  lesson_chart: null,
  class_topic: null,
  event_tools: null,
  planner_f_list: null,
  home_f_list: null,
  planner_list: null,
  home_list: null,
  class_teacher_fio: '',
  teacher_fio: '',
  loading: false
};


export default function classbook(state = initialState, action) {
  switch (action.type) {

    case types.GET_CLASSBOOK_STUDY_PERIOD:
      return {
        ...state,
        studyPeriod: action.payload
      };

    case types.GET_CLASSBOOK_LESSON:
      return {
        ...state,
        lessons: action.payload
      };
    case types.GET_CLASSBOOK_CLASS:
      return {
        ...state,
        scClass: action.payload
      };
    case types.GET_CLASSBOOK_GRADE_VALUE: {
      const raw = action.payload;
      const gradeValue = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.grade_value) ? raw.grade_value
        : Array.isArray(raw?.grades) ? raw.grades
        : [];
      return { ...state, gradeValue };
    }
    case types.GET_LESSON_CHART:
      return {
        ...state,
        lesson_chart: action.payload
      };
    case types.GET_CLASS_TOPIC:
      return {
        ...state,
        class_topic: action.payload
      };
    case types.GET_EVENT_TOOLS:
      return {
        ...state,
        event_tools: action.payload
      };
    case types.GET_PLANNERF_LIST:
      return {
        ...state,
        planner_f_list: action.payload
      };
    case types.GET_HOMEWORKF_LIST:
      return {
        ...state,
        home_f_list: action.payload
      };
    case types.GET_PLANNER_LIST:
      return {
        ...state,
        planner_list: action.payload
      };
    case types.GET_HOMEWORK_LIST:
      return {
        ...state,
        home_list: action.payload
      };

    case types.GET_CLASSBOOK:
      return {
        ...state,
        classbook: action.payload.group_journal,
        class_teacher_fio: action.payload.class_teacher_fio,
        teacher_fio: action.payload.teacher_fio,
      };
    case types.SET_STUDENTS_LIST_FOR_GENERAL_INFO:
      return {
        ...state,
        students_list: action.payload
      };
    case types.SET_STUDENTS_LIST_FOR_GENERAL_INFO_EXPELLED:
      return {
        ...state,
        expelled_students: action.payload
      };
    case types.GET_RECOMMENDATIONS:
      return {
        ...state,
        recommendations: action.payload
      };
    case types.GET_ABSENCES:
      return {
        ...state,
        absences: action.payload
      };
    case types.GET_ATTENDANCES:
      return {
        ...state,
        attendance: action.payload
      };
    case types.GET_CLASSBOOK_SUMMARY:
      return {
        ...state,
        summary: action.payload
      };
    case types.GET_CLASSBOOK_GRADE_TYPES:
      return {
        ...state,
        grade_types: action.payload
      };

    case types.SET_CLASSBOOK_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case types.UPDATE_LESSON_CHART: {
      if (!state.lesson_chart) return state;
      return {
        ...state,
        lesson_chart: state.lesson_chart.map(item =>
          item.sh_mod_fact_id === action.payload.sh_mod_fact_id
            ? { ...item, ...action.payload }
            : item
        )
      };
    }

    case types.UPDATE_CLASSBOOK_GRADE: {
      // 1. Обновляем оценку и комментарий ученика
      const updatedClassbook = state.classbook.map(item =>
        (item.mid === action.payload.mid && item.lessonid === action.payload.lessonid)
          ? {
              ...item,
              grade: action.payload.grade,
              ...(action.payload.gradecomment !== undefined && { gradecomment: action.payload.gradecomment }),
            }
          : item
      );

      // 2. Пересчитываем средний балл для колонки (по lessonunixdate)
      const columnGrades = updatedClassbook
        .filter(item => item.lessonunixdate === action.payload.lessonunixdate && item.mid !== 99999)
        .map(item => item.grade)
        .filter(grade => grade)
        .flatMap(grade => String(grade).split('').map(Number))
        .filter(n => n >= 1 && n <= 5);

      const columnAvg = columnGrades.length > 0
        ? (columnGrades.reduce((sum, g) => sum + g, 0) / columnGrades.length).toFixed(2)
        : '';

      // 3. Пересчитываем средний балл для студента (все его оценки)
      const studentGrades = updatedClassbook
        .filter(item => item.mid === action.payload.mid && item.lessondate !== 'Ср. балл' && item.lessonunixdate < 9999999999)
        .map(item => item.grade)
        .filter(grade => grade)
        .flatMap(grade => String(grade).split('').map(Number))
        .filter(n => n >= 1 && n <= 5);

      const studentAvg = studentGrades.length > 0
        ? (studentGrades.reduce((sum, g) => sum + g, 0) / studentGrades.length).toFixed(2)
        : '';

      // 4. Обновляем оба средних балла
      const finalClassbook = updatedClassbook.map(item => {
        // Средний балл колонки (строка mid === 99999)
        if (item.mid === 99999 && item.lessonunixdate === action.payload.lessonunixdate) {
          return { ...item, grade: columnAvg };
        }
        // Средний балл студента (колонка "Ср. балл")
        if (item.mid === action.payload.mid && item.lessondate === 'Ср. балл') {
          return { ...item, grade: studentAvg };
        }
        return item;
      });

      return {
        ...state,
        classbook: finalClassbook
      };
    }

    default:
      return state;
  }
}